import { BaseModal } from "../../../../components/common/BaseModal/BaseModal";
import { LabeledSelect } from "../../../../components/common/LabeledSelect/LabeledSelect";
import {
  useAskForQuotationServicePostApiAskForQuotationAskForQuotationEmail,
  useEasyServiceGetApiEasyAdministrationAreaCountryList,
  useEasyServicePutApiEasyAdministrationArea,
} from "../../../../openapi/api/queries/queries";
import { Countries } from "../../../../openapi/api/requests/types.gen";

import { JSX, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "@4pace-cpq/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";

export function AdministrationAreaDialog({
  setAdministrationArea,
}: {
  setAdministrationArea: (administrationArea: string) => void;
}): JSX.Element {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  const [administrationAreaValue, setAdministrationAreaValue] = useState("");
  const [errorLoading, setErrorLoading] = useState(false);

  const { data: AdministrationAreaCountryList } =
    useEasyServiceGetApiEasyAdministrationAreaCountryList();

  const [countries, setCountries] = useState<Countries[]>(
    AdministrationAreaCountryList?.countries ?? [],
  );

  const { mutate: AskForQuotation } =
    useAskForQuotationServicePostApiAskForQuotationAskForQuotationEmail();

  const { mutate: setAdministrationAreaData } =
    useEasyServicePutApiEasyAdministrationArea();

  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    if (
      AdministrationAreaCountryList &&
      AdministrationAreaCountryList.countries
    ) {
      setCountries(AdministrationAreaCountryList?.countries);
    }
  }, [AdministrationAreaCountryList]);

  function refetchAskForQuotation(): void {
    AskForQuotation(
      {
        requestBody: {
          language: selectedLanguage?.languageCode?.split("-")[0],
        },
      },
      {
        onSuccess: (data) => {
          setErrorLoading(false);
          if (data.countries) {
            setCountries(data.countries);
          }
        },
        onError: (e) => {
          setErrorLoading(true);
          console.error(e);
        },
      },
    );
  }

  function handleConfirm(): void {
    setAdministrationAreaData(
      {
        requestBody: {
          string: administrationAreaValue,
        },
      },
      {
        onSuccess: (data) => {
          setIsOpen(false);
          if (data.string) {
            setAdministrationArea(data.string);
          }
        },
        onError: (e) => {
          console.error(e);
        },
      },
    );
  }

  return (
    <>
      <BaseModal
        title={t("WEG:dialog.administrationArea.header")}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hideClose={true}
      >
        <Box sx={{ display: "flex", minWidth: "350px" }}>
          {errorLoading && (
            <Box display="flex" justifyContent="center" alignItems={"end"}>
              <IconButton aria-label="reload" onClick={refetchAskForQuotation}>
                <RefreshIcon fontSize="inherit" />
              </IconButton>
            </Box>
          )}
          <LabeledSelect
            fullWidth={true}
            label={t("WEG:label.country")}
            value={administrationAreaValue}
            handleChange={(e) => setAdministrationAreaValue(e.toString())}
            sx={{ width: "100%" }}
          >
            {countries.map((country, idx) => {
              return (
                <MenuItem key={idx} value={country.value ?? ""}>
                  {country.label}
                </MenuItem>
              );
            })}
          </LabeledSelect>
        </Box>
        <Box display="flex" justifyContent="flex-end" pt={4}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={!administrationAreaValue}
          >
            {t("WEG:btn.setAdministrationArea")}
          </Button>
        </Box>
      </BaseModal>
    </>
  );
}
